// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1OAOL","alert":"SettungsInbox_alert__1g38L"};